(function () {
  function initOriginals(root) {
    if (!root || root.dataset.originalsReady === 'true') return;

    var grid = root.querySelector('#product-grid');
    var buttons = root.querySelectorAll('[data-rp-filter]');
    var status = root.querySelector('[data-rp-count]');
    var details = root.querySelector('.rp-originals-filter');
    var sort = root.querySelector('[data-rp-sort]');

    if (!grid) return;
    root.dataset.originalsReady = 'true';

    function applyFilter(value) {
      var cards = grid.querySelectorAll('[data-rp-family]');
      var visible = 0;

      cards.forEach(function (card) {
        var matches = value === 'all' || card.dataset.rpFamily === value;
        card.hidden = !matches;
        if (matches) visible += 1;
      });

      buttons.forEach(function (button) {
        button.setAttribute('aria-pressed', String(button.dataset.rpFilter === value));
      });

      if (status) status.textContent = visible + (visible === 1 ? ' design' : ' designs');
      if (details) details.open = false;
    }

    buttons.forEach(function (button) {
      button.addEventListener('click', function () {
        applyFilter(button.dataset.rpFilter);
      });
    });

    if (sort) {
      sort.addEventListener('change', function () {
        sort.form.submit();
      });
    }

    applyFilter('all');
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-rp-originals]').forEach(initOriginals);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
